import { ActionType } from 'typesafe-actions'
import * as actions from './actions'

export type FooterAction =
  | ActionType<typeof actions.fetchPhonesRequest>
  | ActionType<typeof actions.fetchPhonesSuccess>
  | ActionType<typeof actions.fetchPhonesFail>

export interface FooterState {
  patientSupportPhone: string
  technicalSupportPhone: string
}

export enum FooterActionTypes {
  FETCH_PHONES_REQUEST = '@@footer/FETCH_PHONES_REQUEST',
  FETCH_PHONES_SUCCESS = '@@footer/FETCH_PHONES_SUCCESS',
  FETCH_PHONES_FAIL = '@@footer/FETCH_PHONES_FAIL'
}
